import Vue from 'vue';
import grillshopModule from '../store/grillshop';
import { loadProducts } from '@breakmedia/prime-vue-product/src/store/getProducts';

const grillshop = {
    getBasketTotalExclVat() {
        const basketSubtotalExclVat = this.getBasketSubTotalExclVat();
        const shippingTotal = Vue.$basket.getShippingTotal();
        const productsFeesTotal = Vue.$basket.getProductsFeesTotal();
        const totalDiscount = Vue.$basket.getTotalDiscount();

        const basketMaxVat = this.getBasketMaxVat();

        return basketSubtotalExclVat +
            this.calculateNetPrice((shippingTotal + productsFeesTotal - totalDiscount), basketMaxVat);
    },

    getBasketSubTotalExclVat() {
        let total = 0;
        const items = Vue.$basket.getBasketItems();
        Object.values(items).forEach(item => {
            total += this.getBasketItemTotalPriceExclVat(item) * item.quantity;
        });
        return total;
    },

    getBasketItemTotalPriceExclVat(item) {
        let vat = this.getBasketItemVat(item);
        let price = Vue.$basket.getPriceData(item, null).price;
        return this.calculateNetPrice(price, vat);
    },

    getBasketMaxVat() {
        let vat = [];
        const items = Vue.$basket.getBasketItems();
        Object.values(items).forEach(item => {
            vat.push((this.getBasketItemVat(item) > 0) ? this.getBasketItemVat(item) : 0);
        });
        return Math.max.apply(Math, vat);
    },

    getBasketItemVat(item) {
        return parseInt(Vue.$basket.getPriceData(item, null).VAT ? Vue.$basket.getPriceData(item, null).VAT : 0);
    },

    calculateNetPrice(price, vat) {
        return price * 100 / (100 + vat);
    },

};

const getCanonicalProductPath = product => {
    if (!product) {
        return null;
    }

    const getProductAttributeByLanguage = Vue.$store.getters['Product/getProductAttributeByLanguage'];
    if (typeof getProductAttributeByLanguage !== 'function') {
        return null;
    }

    const slug = getProductAttributeByLanguage(product, 'product.url');
    if (!slug) {
        return null;
    }

    return `/${slug.replace(/^\/+/, '')}`;
};

const resolveCanonicalProductPath = async productId => {
    if (!productId) {
        return null;
    }

    if (!/^\d+$/.test(productId)) {
        return `/${productId}`;
    }

    const products = await loadProducts({
        ids: [productId.toString()],
        priceParams: [],
        fields: 'id attributes',
    });

    return getCanonicalProductPath(products[0]);
};

const getLegacyProductKey = to => {
    if (!to || !to.path) {
        return null;
    }

    if (to.name === 'merchant-product' && to.params && to.params.id) {
        return to.params.id;
    }

    const segments = to.path.split('/').filter(Boolean);
    const productIndex = segments.lastIndexOf('product');
    if (productIndex < 0) {
        return null;
    }

    // Normalize only /.../product/<key> legacy product urls.
    if (productIndex !== segments.length - 2) {
        return null;
    }

    return segments[productIndex + 1] || null;
};

export default {
    install: function(Vue) {
        if (!Vue.$store.state['Grillshop']) {
            Vue.$store.registerModule('Grillshop', grillshopModule);
        }

        if (Vue.$order && typeof Vue.$order.getDeliveryCountry === 'function') {
            Vue.$store.watch(Vue.$order.getDeliveryCountry, val => {
                Vue.$store.dispatch('Grillshop/queryShippingTypes', {
                    country: val
                });
            });
        }

        Vue.prototype.$grillshop = grillshop;
        Vue.$grillshop = grillshop;

        Vue.$router.beforeEach(async (to, from, next) => {
            const productKey = getLegacyProductKey(to);
            if (!productKey) {
                next();
                return;
            }

            try {
                const canonicalPath = await resolveCanonicalProductPath(productKey);
                if (canonicalPath && canonicalPath !== to.path) {
                    next({
                        path: canonicalPath,
                        query: to.query,
                        hash: to.hash,
                        replace: true,
                    });
                    return;
                }
            } catch (e) {
                // Let the existing route resolve if canonical lookup fails.
            }

            next();
        });
    }
};
